<template>
  <v-card class="pa-4" flat>
    <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
    <DialogLinkPlaylist ref="dlgLinkPL" @save="onLinkPL"></DialogLinkPlaylist>
    <DialogCreateAndLinkPlaylist ref="dlgCreatePL" @save="onCreatePL"></DialogCreateAndLinkPlaylist>
    <v-row>
      <v-col cols="12" class="text-right">
        <TableStandorte ref="locations" :showTitle="false" :companyId="companyId" :isCompanyView="true"/>
      </v-col>
      <v-col cols="12" class="text-right pb-0">
        <v-row align="start">
          <v-col cols="12" md="3" xs="12" align="start">
            <v-btn color="primary" @click="openCompanyDialog">Standort zuweisen</v-btn>
          </v-col>
          <v-col cols="12" md="9" xs="12" align="end">
            <v-btn color="primary" @click="createItem()">Standort erstellen</v-btn>
          </v-col>
          <v-col cols="12" md="3" xs="12" v-if="false">
            <v-btn color="primary" @click="openLinkPL">Playlist zuweisen</v-btn>
          </v-col>
          <v-col cols="12" md="3" xs="12" v-if="false">
            <v-btn color="primary" @click="openCreatePL">Playlist erstellen</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vue from 'vue'
import TableStandorte from "../../tables/TableStandorte";
import DialogLinkCompany from './../../module/dialogs/DialogLinkCompany'
import DialogCreateAndLinkPlaylist from './../../module/dialogs/DialogCreateAndLinkPlaylist'
import DialogLinkPlaylist from './../../module/dialogs/DialogLinkPlaylist'

export default {
  name: 'TabStandorte',
  components: {TableStandorte, DialogLinkCompany, DialogLinkPlaylist, DialogCreateAndLinkPlaylist},
  props: {
    companyId: String
  },
  methods: {
    reload: function () {
      this.$refs.locations.reload()
    },
    onCreatePL: function (playListItems) {
      console.log('onCreatePL To selected', playListItems, this.selected)
      let companyArrGuids = []
      for (let i in this.selected) {
        let item = this.selected[i]
        companyArrGuids.push(item.guid)
      }
      let plGuids = []
      for (let i in playListItems) {
        let item = playListItems[i]
        plGuids.push(item.guid)
      }

      console.log('onCreatePL plGuids, companyArrGuids', plGuids, companyArrGuids)
      Vue.prototype.$api.createPlayListToCompanies(plGuids, companyArrGuids, this.reload)
    },
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
      this.companyItem = item
      this.$refs.dlgLink.open({
        title: 'Netzwerk zuweisen',
        description: 'Wählen Sie eine Netzwerk'
      })
    },
    openLinkPL: function () {
      console.log('openLinkPL')
      this.$refs.dlgLinkPL.open({
        title: 'Playlist zuweisen',
        description: 'Wählen Sie eine Playlist'
      })
    },
    openCreatePL: function () {
      console.log('openCreatePL')
      this.$refs.dlgCreatePL.open({
        title: 'Playlist erstellen',
        description: 'Wählen Sie Playlisten zum erstellen und zuweisen neuer Playliste'
      })
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkCompanyToCompany(this.companyId, item, this.reload)
    },
    onLinkPL: function (item) {
      console.log('onLinkPlayList To selected', item, this.selected)
      let companyArrGuids = []
      for (let i in this.selected) {
        let item = this.selected[i]
        companyArrGuids.push(item.guid)
      }
      Vue.prototype.$api.linkPlayListToCompanies(item.guid, companyArrGuids, this.reload)
    },
    open: function () {
    },
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiCompany.createCompany({
        isMother: 0,
        guidParent: this.companyId
      }, this.onCompanyCreated)
    },
    onCompanyCreated: function (newItem) {
      console.log('onCompanyCreated', newItem)
      this.$router.push('/Netzwerke/' + this.companyId + '/Standort/' + newItem.guid)
    }
  },
  data () {
    return {}
  },
  mounted () {

  }
}
</script>

<style scoped>

</style>
